module.exports = __webpack_public_path__ + "img/iap-settings.e4ca9ab9.svg";